/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation, untranslated } from "@i18n";
import { renderUserTag } from "@CubeComponents/html/userTagDom";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { deleteCostDb, saveAddEditCostDb } from "@Actions/portalSetting";

import { useDispatch, useSelector } from "react-redux";
import { convertDate } from "@Services/luxonHelper";
import { GrClose } from "react-icons/gr";
import { showToastNotification } from "@Reducers/toastSlice";
import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import Forbidden from "@Pages/Error/Forbidden";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import CostDatabaseProperties from "./CostDatabaseProperties";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS, TOAST_TYPE_WARNING } from "@Services/constants";
import { getCostDatabaseDataUrl, getCurrencyDataUrl } from "@Services/dataManager";
import axiosWrapper from "@AxiosWrapper";
import type { CurrencyDataItem, GetCurrencyDataResponse } from "@ServerTypes/currency/currency.schema";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import SlickGrid1 from "@CubeComponents/html/SlickGrid1";
import IconComponent from "@CubeComponents/icons";
import { portalCreateRoot as createRoot } from "@CubeComponents/html/cellPortals";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import _ from "lodash";
import Text from "@CubeComponents/html/Text/Text";
import { Box } from "@mui/material";
import { GridPageLayout } from "@CubeComponents/html/GridPageLayout";
import { RootState } from "@Reducers/index";

function CostDatabases(props: any) {
  const { t } = useTranslation();
  const { showOnlyGrid, costDatabaseSelection, costDatabaseQuery } = props;

  const buttonInitialState = {
    create: false,
    edit: true,
    delete: true,
    properties: true,
  };

  const initialNewCostDatabaseData = {
    action: "",
    name: "",
    description: "",
    defaultCostIndex: 1,
    currency: "",
  };

  const [costDatabaseDetails, setCostDatabaseDetails] = useState<any>({});
  const [selectedRowIndexCostDatabase, setSelectedRowIndexCostDatabase] = useState(0);
  const [costDatabaseData, setCostDatabaseData] = useState<any>(initialNewCostDatabaseData);
  const [gridQuery] = useState(costDatabaseQuery ?? {});
  const [toolbarButtonDisableState, setToolbarButtonDisableState] = useState(buttonInitialState);
  const [isGridReady, setIsGridReady] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [currencyOptions, setCurrencyOptions] = useState<CurrencyDataItem[]>([]);

  const portalSettingInfo = useSelector((state: RootState) => state.portalSettingInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dataGrid: any = useRef<any>(null);

  useEffect(() => {
    document.title = t("Portal Settings | Cost Database");
  }, []);

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await axiosWrapper.post<GetCurrencyDataResponse>(getCurrencyDataUrl, {
          value: { params: {} },
        });
        if (response?.data?.result) {
          setCurrencyOptions(response.data.result);
        }
      } catch (error) {
        console.error("Error fetching currency data:", error);
        Promise.reject(error);
      }
    };
    fetchCurrencyData();
  }, []);

  const propertiesBtnTemplate = () => (
    <div className="me-7" data-testid="propertiesCostDatabaseBtn">
      <IconComponent
        name="properties"
        width="1.25rem"
        height="1.25rem"
        onClick={() => toolbarClickHandler("properties")}
      />
    </div>
  );

  const toolbarOptions = [
    {
      id: "create",
      name: t("Add Cost Database"),
      prefixIcon: "add",
      disabled: toolbarButtonDisableState.create,
    },
    {
      id: "edit",
      name: t("Edit"),
      prefixIcon: "editProfile",
      disabled: toolbarButtonDisableState.edit,
    },
    {
      id: "delete",
      name: t("Delete"),
      prefixIcon: "delete",
      disabled: toolbarButtonDisableState.delete,
    },
    {
      id: "properties",
      rightAllign: true,
      template: propertiesBtnTemplate,
      disabled: toolbarButtonDisableState.properties,
    },
  ];

  useEffect(() => {
    setToolbarButtonDisableState((prev) => ({
      ...prev,
      create: !portalSettingInfo?.costDatabase?.addCostDatabases?.enable,
    }));
  }, [portalSettingInfo]);

  const formatDate = (data: any, value: any, a: any, b: any, props: any) => {
    const container = document.createElement("div");
    const root = createRoot(container);
    const dateFormat = convertDate(Number(props.createdDate), "dateForTooltip");
    root.render(
      <div style={{ width: "fit-content" }}>
        <ToolTipComponent showTipPointer position="bottom" content={dateFormat}>
          <span>{convertDate(Number(props.createdDate), "dateForText")}</span>
        </ToolTipComponent>
      </div>,
    );

    return container;
  };

  const recordClick = (args: any) => {
    if (args.detail.args.cell !== 0) {
      const rowData = dataGrid.current.slickGrid.getDataItem(args.detail.args.row);
      if (rowData._id) {
        setCostDatabaseDetails({});
        navigate(`/portalSettings/costDatabases/${rowData._id}`);
      }
    }
  };

  const selectionEvent = () => {
    if (!_.get(dataGrid, "current")) return;

    const selectedRecords = dataGrid.current.dataView
      .getAllSelectedItems()
      .filter((record: any) => record && !record.__isDummy);

    if (showOnlyGrid && costDatabaseSelection) {
      costDatabaseSelection(selectedRecords);
      return;
    }

    if (props.setBtnState) {
      props.setBtnState(selectedRecords.length === 1);
      if (selectedRecords.length === 1 && props.setSelectedCDB) {
        props.setSelectedCDB(selectedRecords[0]);
      }
    }
    if (props.showOnlyGrid) {
      return;
    }

    const canEdit = portalSettingInfo?.costDatabase?.editCostDatabases?.enable;
    const canDelete = portalSettingInfo?.costDatabase?.deleteCostDatabases?.enable;

    setToolbarButtonDisableState((prev) => ({
      ...prev,
      edit: selectedRecords.length !== 1 || !canEdit,
      delete:
        selectedRecords.length == 0 || selectedRecords.some((record: any) => !record.createdBy?.fullName) || !canDelete,
      properties: selectedRecords.length !== 1,
    }));
    if (selectedRecords.length !== 1) {
      setCostDatabaseDetails({});
      setSelectedRowIndexCostDatabase(0);
    }
  };

  const toolbarClickHandler = async (toolClicked: any) => {
    const data = dataGrid.current.dataView.getAllSelectedItems().filter((record: any) => record && !record.__isDummy);

    switch (toolClicked) {
      case "create":
        setCostDatabaseData((prev: any) => ({ ...prev, action: "create" }));
        break;
      case "edit":
        setCostDatabaseData({
          action: "edit",
          name: data[0].name,
          description: data[0].description,
          defaultCostIndex: data[0].defaultCostIndex,
          _id: data[0]._id,
        });
        break;
      case "delete":
        setOpenDeleteModal(true);
        break;
      case "properties":
        openProperties({ index: null, isForward: null });
        break;
    }
  };

  const createdByTemplate = (data: any, value: any, a: any, b: any, args: any) => {
    const container = document.createElement("div");

    if (args.createdBy && typeof args.createdBy !== "string") {
      renderUserTag(container, { id: args.createdBy._id });
    } else {
      container.textContent = t("SYSTEM GENERATED");
    }
    return container;
  };

  const handleCurrencyChange = (_event: any, newValue: any) => {
    setCostDatabaseData((prev: any) => ({ ...prev, currency: newValue?.id }));
  };

  const validationForCreateAndEditCostDatabase = (showToast = false) => {
    if (Number.isNaN(costDatabaseData.defaultCostIndex) || costDatabaseData.defaultCostIndex <= 0) {
      if (showToast) {
        dispatch(
          showToastNotification({
            content: t("Please enter a positive value for Default Cost Index."),
            type: TOAST_TYPE_WARNING,
          }),
        );
      }
      return false;
    }
    if (
      !costDatabaseData.name.trim() ||
      !costDatabaseData.description.trim() ||
      (!costDatabaseData._id && !costDatabaseData.currency)
    ) {
      return false;
    }
    return true;
  };

  const createCostDatabase = async () => {
    const data = {
      name: costDatabaseData.name.trim(),
      description: costDatabaseData.description.trim(),
      currencyId: costDatabaseData.currency,
      defaultCostIndex: costDatabaseData.defaultCostIndex,
    };
    const response = await saveAddEditCostDb(data);
    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: t("create_costDatabase", { name: costDatabaseData.name }),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      closeCDBModal();
      dataGrid.current?.refresh();
    } else {
      dispatch(
        showToastNotification({
          content: untranslated(response.data.errorMessage ?? SOMETHING_WENT_WRONG),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  const editCostDatabase = async () => {
    const data = {
      name: costDatabaseData.name.trim(),
      description: costDatabaseData.description.trim(),
      _id: costDatabaseData._id,
      defaultCostIndex: costDatabaseData.defaultCostIndex,
    };

    const response = await saveAddEditCostDb(data);
    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: t("edit_costDatabase", { name: data.name }),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      closeCDBModal();
      dataGrid.current?.refresh();
    } else {
      dispatch(
        showToastNotification({
          content: untranslated(response.data.errorMessage ?? SOMETHING_WENT_WRONG),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  const createEditCD = async () => {
    setIsButtonLoading(true);
    const validationResults = validationForCreateAndEditCostDatabase(true);
    if (validationResults) {
      if (costDatabaseData._id) {
        await editCostDatabase();
      } else {
        await createCostDatabase();
      }
    }
    setIsButtonLoading(false);
  };

  const closeCDBModal = () => {
    setCostDatabaseData(initialNewCostDatabaseData);
  };

  const createCostDbModal = () => (
    <div>
      <Box className="fixed inset-0 z-[1000] bg-[var(--background-scrim)]" onClick={() => closeCDBModal()} />
      <div className="fixed start-1/2 top-1/2 z-[1000] w-[25rem] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8">
        <div className="flex w-full items-center justify-between pb-4">
          <Text
            className="text-[1.375rem] font-semibold"
            data-testid={costDatabaseData._id ? "editCostDatabase" : "createNewCostDatabase"}
          >
            {" "}
            {costDatabaseData._id ? t("Edit Cost Database") : t("Create New Cost Database")}
          </Text>
          <GrClose size={20} className="cursor-pointer" onClick={() => closeCDBModal()} data-testid="closeCDModalBtn" />
        </div>
        <div className="flex flex-col">
          <label htmlFor="Name" className="mb-2 mt-4 text-sm text-[#333]" data-testid="createCDNameLabel">
            <Text>{t("Cost Database")}</Text>
          </label>
          <input
            data-testid="createCDNameInputBox"
            className="mb-[0.4rem] w-full resize-none border border-[#19204880] px-2 py-[0.42rem] outline-none placeholder:text-[#19204880] focus:border-[#0078d4] focus:py-[0.44rem]"
            type="text"
            minLength={1}
            maxLength={255}
            name="Name"
            placeholder={t("Cost Database")}
            value={costDatabaseData.name}
            onChange={(event) => setCostDatabaseData((prev: any) => ({ ...prev, name: event.target.value }))}
          />
          <label htmlFor="description" className="mb-2 mt-4 text-sm text-[#333]" data-testid="createCDDescriptionLabel">
            <Text>{t("Description")}</Text>
          </label>
          <textarea
            className="mb-[0.4rem] w-full resize-none border border-[#19204880] px-2 py-[0.42rem] outline-none placeholder:text-[#19204880] focus:border-[#0078d4] focus:py-[0.44rem]"
            // type="textarea"
            rows={5}
            minLength={1}
            maxLength={255}
            name="description"
            placeholder={t("Cost database description")}
            value={costDatabaseData.description}
            onChange={(event) => setCostDatabaseData((prev: any) => ({ ...prev, description: event.target.value }))}
            data-testid="createCDDescriptionInputBox"
          />
          <label className="mb-2 mt-4 text-sm text-[#333]" data-testid="createCDDefaultCDIndexLabel">
            {" "}
            <Text>{t("Default Cost Index")} </Text>
          </label>
          <TextFieldComponent
            type="number"
            placeholder={t("Enter Value")}
            value={costDatabaseData.defaultCostIndex}
            onChange={(event) =>
              setCostDatabaseData((prev: any) => ({
                ...prev,
                defaultCostIndex: event.target.value ? Number(event.target.value) : null,
              }))
            }
            slotProps={{
              htmlInput: {
                "data-testid": "createCDDefaultCDIndexInputBox",
              },
            }}
          />
          {costDatabaseData._id ? null : (
            <>
              <label htmlFor="Currency" className="mb-2 mt-4 text-sm text-[#333]" data-testid="currencyLabel">
                <Text>{t("Currency")}</Text>
              </label>
              <AutoComplete
                valueField="id"
                getOptionLabel={(option) =>
                  option ? `${option.name} - ${option.selected_currency_symbol?.selectedSymbol || ""}` : ""
                }
                onChange={handleCurrencyChange}
                options={currencyOptions}
                data-testid="createCDCurrencyDropdown"
                value={currencyOptions.find((opt) => opt.id === costDatabaseData.currency) || null}
                renderInput={(params: any) => <TextFieldComponent {...params} placeholder={t("Select Currency")} />}
              />
            </>
          )}
        </div>
        <div className="mt-8 flex justify-between">
          <ButtonComponent
            data-testid={costDatabaseData._id ? "saveCostDatabase" : "createCostDatabase"}
            disabled={!validationForCreateAndEditCostDatabase()}
            onClick={createEditCD}
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
            loading={isButtonLoading}
          >
            <Text>{t(costDatabaseData._id ? "Save" : "Create")}</Text>
          </ButtonComponent>
        </div>
      </div>
    </div>
  );

  const dataBound = (val: any) => {
    setIsGridReady(val);
  };

  const [gridColumns] = useState([
    {
      field: "name",
      name: t("Name"),
      id: "name",
      textAlign: "Left",
      filterType: "Text",
      minWidth: 170,
    },
    {
      field: "description",
      name: t("Description"),
      id: "description",
      textAlign: "Left",
      filterType: "Text",
      minWidth: 170,
    },
    {
      field: "defaultCostIndex",
      name: t("Default Cost Index"),
      id: "defaultCostIndex",
      textAlign: "Left",
      filterType: "Number",
      minWidth: 120,
    },
    {
      field: "currency.name",
      name: t("Currency"),
      id: "currencyName",
      textAlign: "Left",
      filterType: "Text",
      clipMode: "EllipsisWithTooltip",
      _valueGetter: (props: any) => props.currency.name,
      minWidth: 150,
    },
    {
      field: "createdDate",
      name: t("Created On"),
      id: "createdDate",
      textAlign: "Left",
      // filterType: "Date",
      formatter: formatDate,
      minWidth: 120,
    },
    {
      field: "createdBy",
      name: t("Created by"),
      id: "createdBy",
      textAlign: "Left",
      filterType: "Text",
      formatter: createdByTemplate,
      _valueGetter: (props: any) => props.createdBy.fullName,
      minWidth: 150,
    },
  ]);

  const CostDatabaseGridData = () => (
    <div className="overflow-auto h-full w-full">
      <SlickGrid1
        ref={dataGrid}
        columnDefinitions={gridColumns as any}
        enableSortingOption
        onSelectedRowIdsChanged={selectionEvent}
        remoteDataSource={getCostDatabaseDataUrl}
        query={gridQuery}
        infiniteScroll
        enableRowResize
        enableFilteringOption
        enableColumnChooser
        setGridReady={dataBound}
        toolbar={(showOnlyGrid ? null : toolbarOptions) as any}
        toolbarClickHandler={toolbarClickHandler}
        onClick={(showOnlyGrid ? null : recordClick) as any}
      />
    </div>
  );

  function openProperties({ index, isForward }: any) {
    let itemData;
    if (index != null) {
      const condition = isForward ? 1 : -1;
      if (dataGrid.current.dataView.items.length == index + condition) {
        itemData = dataGrid.current.dataView.items[0];
        setSelectedRowIndexCostDatabase(0);
        dataGrid.current.slickGrid.setSelectedRows([0]);
      } else if (index + condition == -1) {
        itemData = dataGrid.current.dataView.items[dataGrid.current.dataView.items.length - 1];
        setSelectedRowIndexCostDatabase(dataGrid.current.dataView.items.length - 1);
        dataGrid.current.slickGrid.setSelectedRows([dataGrid.current.dataView.items.length - 1]);
      } else {
        itemData = dataGrid.current.dataView.items[index + condition];
        setSelectedRowIndexCostDatabase(index + condition);
        dataGrid.current.slickGrid.setSelectedRows([index + condition]);
      }
    } else {
      const index = dataGrid.current.slickGrid.getSelectedRows()[0];
      setSelectedRowIndexCostDatabase(index);
      itemData = dataGrid.current.slickGrid.getDataItem(index);
    }
    if (itemData) {
      const { _id, name, description, defaultCostIndex, currency, createdDate, createdBy } = itemData;
      setCostDatabaseDetails({
        _id,
        name,
        description,
        defaultCostIndex,
        currencyId: currency.id,
        createdDate,
        createdBy: createdBy?.fullName ?? "",
        createdById: createdBy?._id,
        currencyName: currency.name,
      });
    }
  }

  useEffect(() => {
    if (isGridReady && props.selectedCDB) {
      const index = dataGrid.current.dataView.items.findIndex((record: any) => record._id == props.selectedCDB._id);
      if (index != -1) {
        dataGrid.current.slickGrid.setSelectedRows([index]);
      }
    }
  }, [isGridReady]);

  const handleCloseSidebar = () => {
    setCostDatabaseDetails({});
  };

  const cancelDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const handleDelete = async () => {
    setIsButtonLoading(true);
    const selectedRecords = dataGrid.current.dataView
      .getAllSelectedItems()
      .filter((record: any) => record && !record.__isDummy);
    const response = await deleteCostDb(selectedRecords.map((record: any) => record._id));
    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: t("Cost Database(s) have been deleted successfully."),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      dataGrid.current?.refresh();
    } else {
      dispatch(
        showToastNotification({
          content: untranslated(response.data.errorMessage ?? SOMETHING_WENT_WRONG),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
    setIsButtonLoading(false);
    cancelDeleteModal();
  };

  const deleteFooter = () => (
    <div className="w-full flex gap-5">
      <ButtonComponent buttonType={BUTTON_TYPES.GRADIENT_BUTTON} onClick={handleDelete} loading={isButtonLoading}>
        <Text>{t("Delete")}</Text>
      </ButtonComponent>
      <ButtonComponent
        buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
        onClick={cancelDeleteModal}
        disabled={isButtonLoading}
      >
        <Text>{t("Cancel")}</Text>
      </ButtonComponent>
    </div>
  );

  const deleteCostDatabaseModal = () => (
    <ModalStateDialogComponent
      footerContent={deleteFooter()}
      headerTitle={t("Delete Cost Database(s)")}
      isVisible={openDeleteModal}
      onCancel={isButtonLoading ? undefined : cancelDeleteModal}
      modelContent={
        <Text className="text-sm" sx={{ whiteSpace: "normal" }}>
          {t("Are you sure you want to delete the selected Cost Database(s)?")}
        </Text>
      }
      width="28.125rem"
    />
  );

  return (
    <>
      {!portalSettingInfo?.costDatabase?.isVisible && !showOnlyGrid ? (
        <Forbidden />
      ) : (
        <GridPageLayout
          showHeader={!showOnlyGrid}
          title="Cost Databases"
          description="List of all the cost databases in this portal"
        >
          <div className="flex justify-between gap-3 h-full w-full overflow-hidden">
            {CostDatabaseGridData()}
            {costDatabaseDetails._id && (
              <CostDatabaseProperties
                costDatabaseDetails={costDatabaseDetails}
                openProperties={openProperties}
                index={selectedRowIndexCostDatabase}
                setShowProperties={handleCloseSidebar}
              />
            )}
          </div>
        </GridPageLayout>
      )}
      {costDatabaseData.action && createCostDbModal()}
      {openDeleteModal && deleteCostDatabaseModal()}
    </>
  );
}

export default CostDatabases;
